// Business unit configuration: route, color tokens, hero image, card image
// Royalty-free images from Unsplash (industrial themes matching the reference)
export const UNITS = [
  {
    key: "metal",
    slug: "metal",
    accent: "#5aa1d6", // blue
    accentSoft: "rgba(90,161,214,0.18)",
    heroImage: "/images/hero-metal.jpg",
    image: "/images/card-metal.jpg",
  },
  {
    key: "urban",
    slug: "urban",
    accent: "#7ec043", // green
    accentSoft: "rgba(126,192,67,0.18)",
    heroImage: "/images/hero-urban.jpg",
    image: "/images/card-urban.jpg",
  },
  {
    key: "plastics",
    slug: "plastics",
    accent: "#4fc2c0", // teal
    accentSoft: "rgba(79,194,192,0.18)",
    heroImage: "/images/hero-plastics.jpg",
    image: "/images/card-plastics.jpg",
  },
  {
    key: "packaging",
    slug: "packaging",
    accent: "#d98246", // orange
    accentSoft: "rgba(217,130,70,0.18)",
    heroImage: "/images/hero-packaging.jpg",
    image: "/images/card-packaging.jpg",
  },
  {
    key: "lighting",
    slug: "lighting",
    accent: "#d4a249", // gold/olive
    accentSoft: "rgba(212,162,73,0.18)",
    heroImage: "/images/hero-lighting.jpg",
    image: "/images/card-lighting.jpg",
  },
];

export const UNIT_BY_SLUG = Object.fromEntries(UNITS.map((u) => [u.slug, u]));
